module.exports = __webpack_public_path__ + "static/media/motorboat.b1e34001.svg";